import { MyAccountMyWishlist as AdvoxMyAccountMyWishlist } from 'AdvoxComponent/MyAccountMyWishlist/MyAccountMyWishlist.component';
import Loader from 'Component/Loader';

/** @namespace Pwa/Component/MyAccountMyWishlist/Component */
export class MyAccountMyWishlist extends AdvoxMyAccountMyWishlist {
    renderAddAllToCart() {
        const { addAllToCart, isActionsDisabled, isEditingActive, isMobile, isLoading, isQtyUpdateInProgress } =
            this.props;

        const isDisabled = (isMobile && isEditingActive) || isActionsDisabled || isLoading || isQtyUpdateInProgress;

        return (
            <button
                block="Button"
                mix={{ block: 'MyAccountMyWishlist', elem: 'Button' }}
                onClick={addAllToCart}
                disabled={isDisabled}
            >
                {__('Add All to Cart')}
            </button>
        );
    }

    renderActionBar() {
        const { isActionsDisabled } = this.props;
        if (isActionsDisabled) {
            return null;
        }

        return (
            <div block="MyAccountMyWishlist" elem="ActionBar">
                {this.renderAddAllToCart()}
                {this.renderShareWishlistButton()}
                {this.renderClearWishlist()}
            </div>
        );
    }

    renderProducts(wishlistItems) {
        const { isWishlistLoading, isWishlistEmpty } = this.props;

        if (!wishlistItems || (isWishlistLoading && isWishlistEmpty)) {
            return this.renderPlaceholders();
        }

        return Object.entries(wishlistItems).map(this.renderProduct.bind(this));
    }

    renderContent() {
        const { wishlistItems, isWishlistLoading, isWishlistEmpty, isLoading } = this.props;

        if (isWishlistEmpty && !isWishlistLoading) {
            return this.renderNoProductsFound();
        }

        return (
            <div block="MyAccountMyWishlist" elem="Products" ref={this.productsRef}>
                <Loader isLoading={isLoading} />
                {this.renderProducts(wishlistItems)}
            </div>
        );
    }
}

export default MyAccountMyWishlist;
